module.exports = __webpack_public_path__ + "img/品牌赛事_2@2x.06ae0a25.png";